/*eslint-disable*/
import _ from 'lodash'
import CourseApi from '../../api/course'

export default [
    {
        path: 'course/create',
        name: 'course:create',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "course" */'../../components/course/Create.vue'),
        meta: {
            title: 'router.router_addCourse',
            prev: {
                name: 'course:list'
            }
        },

    },
    {
        path: 'course/:id',
        name: 'course:profile',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "course" */'../../components/profiles/Course.vue'),
        meta: {
            title: _.throttle((route) => {
                return CourseApi.getCourseName(route.params.id).then((data) => {
                    return data.name;
                });
            }, 100, {trailing: false}),
            prev: {
                name: 'course:list'
            }
        },
        props: true
    },
    {
        path: 'course/:id/edit',
        name: 'course:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "course" */'../../components/course/Edit.vue'),
        meta: {
            title: 'router.router_editCourse',
            prev: {
                name: 'course:profile'
            }
        },
        props: true
    },
]
